import React from "react";

const ChiSiamo = () => {
  return (
    <div className="flex flex-col items-center w-full ">
      <p className="text-red-600 font-extrabold xs:text-2x1 md:text-3xl">
        CHI SIAMO
      </p>
      <div className="w-3/4 text-center">
        <p className="text-red-600 font-bold">
          Promuoviamo la Passione per la Musica, Ispiriamo la Comunità
        </p>
        <p>
          Siamo lieti di presentarvi MilArte, un'Associazione di Promozione
          Sociale dedicata alla musica. Fondata nel 2023, ci impegniamo a
          diffondere la passione per la musica e a creare un impatto positivo
          nella nostra comunità attraverso iniziative musicali significative.
        </p>
        <p>
          <p className="font-extrabold">Storia e Background: </p>Nata dalla
          visione di{" "}
          <a href="https://www.giuseppedinardo.it/" className="text-red-600">
            Giuseppe Dinardo
          </a>{" "}
          , MilArte è stata fondata con l'obiettivo di diffondere la cultura
          musicale. Nel corso degli anni, abbiamo consolidato la nostra presenza
          nel panorama musicale locale grazie alla dedizione dei nostri membri e
          al sostegno della comunità.
        </p>
        <p>
          <p className="font-extrabold">Obiettivi e Missioni:</p> Abbiamo come
          obiettivo proporre concerti, eventi, manifestazioni varie. Crediamo
          che la musica possa trasformare e arricchire la vita di tutti, e
          lavoriamo instancabilmente per rendere la musica accessibile a tutti.
        </p>
        <p>
          <p className="font-extrabold">Attività: </p>Tra le nostre attività
          spiccano programmi e iniziative.
        </p>
        <p>
          <p className="font-extrabold">Membri e Struttura Organizzativa:</p> Il
          cuore pulsante diMilArte è il nostro team, guidati dal Presidente{" "}
          <a href="https://www.giuseppedinardo.it/" className="text-red-600">
            Giuseppe Dinardo
          </a>{" "}
          .
        </p>
        <p>
          <p className="font-extrabold">Successi e Realizzazioni:</p> Nello
          scorso dicembre 2023, abbiamo organizzato concerti, riscuotendo
          successo e apprezzamento da parte della comunità, ma sappiamo che c'è
          ancora molto da fare.
        </p>
        <p>
          <p className="font-extrabold">Partnerships e Sostenitori:</p>{" "}
          Ringraziamo i nostri preziosi partnerships . Senza il loro sostegno,
          le nostre iniziative non sarebbero state possibili.
        </p>
        <p>
          <p className="font-extrabold">Progetti Futuri: </p>Per il futuro,
          MilArte ha in serbo diversi progetti. Siamo entusiasti di continuare a
          crescere e di portare ancora più musica nelle vite delle persone.
        </p>
        <p>
          <p className="font-extrabold">Come Partecipare:</p> Vuoi unirti a noi
          nel nostro viaggio musicale?
        </p>
        <p>
          <p className="font-extrabold">Contatti:</p> Per ulteriori
          informazioni, non esitate a contattarci qui. Seguiteci anche sui
          social media [nomi dei social media] per rimanere aggiornati sulle
          nostre attività.
        </p>
        <p className="font-extrabold">
          Grazie per il vostro tempo e il vostro sostegno
        </p>
      </div>
    </div>
  );
};

export default ChiSiamo;
